import type { ReactNode } from 'react';

export const symbol_head_mounted_device: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M296-240q-64 0-108.5-45.5T143-396v-171q0-49 30-86.5t78-46.5q57-11 114-15.5t115-4.5q58 0 115.5 4.5T710-700q48 9 78 46.5t30 86.5v171q0 65-44.5 110.5T665-240h-42q-12 0-24.5-2t-23.5-6l-65-22q-14-5-29.5-5t-29.5 5l-65 22q-12 4-24 6t-25 2h-41Zm0-60h41q8 0 15-1.5t15-3.5q29-9 56.5-19.5T481-335q29 0 57 10.5t56 19.5q7 2 14 3.5t15 1.5h42q39 0 66-28.5t27-67.5v-171q0-27-16.5-48T699-641q-54-11-109-15t-110-4q-55 0-109.5 4T262-641q-26 5-42.5 26T203-567v171q0 39 27 67.5t66 28.5ZM60-396q-8 0-14-6t-6-14v-131q0-8 6-14t14-6q8 0 14 6t6 14v131q0 8-6 14t-14 6Zm840 0q-8 0-14-6t-6-14v-131q0-8 6-14t14-6q8 0 14 6t6 14v131q0 8-6 14t-14 6Zm-419-84Z"
		/>
	</svg>
);
